///	<reference path="./tsb.d.ts"/>

export default class Cache
{
	private prefix:string = ``

	constructor( prefix:string )
	{
		this.prefix = prefix
	}

	private timestamp():number
	{
		return Date.parse( new Date().toString() ) / 1000
	}

	/**
	 * 将数据写入缓存
	 * @param k 键
	 * @param v 值
	 * @param t 有效期
	 * @returns 
	 */
	put( k:string, v:any, t:number ):void
	{
		let life:number = typeof t == undefined || t == null ? 0 : t;
		let item = {
			timestamp : life === 0 ? 0 : this.timestamp() + life,
			item : v
		};

		return localStorage.setItem( `${this.prefix}${k}`, JSON.stringify( item ) )
	}

	/**
	 * 获取缓存数据
	 * @param k 键
	 * @returns 
	 */
	get( k:string ):boolean | JSON | string
	{
		let source:item = localStorage.getItem( `${this.prefix}${k}` ) !== null ? JSON.parse( localStorage.getItem( `${this.prefix}${k}` ) || '' ) : false
		let current:number = this.timestamp()

		if( !source ) return false
		
		if( source.timestamp !== 0 && current > source.timestamp )
			this.remove( k )
		else
			return source.item

		return false
	}

	/**
	 * 移除某一个值
	 * @param k 键
	 * @returns 
	 */
	remove( k:string ):void
	{
		return localStorage.removeItem( `${this.prefix}${k}` )
	}

	/**
	 * 清除缓存
	 * @returns 
	 */
	clear():void
	{
		return localStorage.clear()
	}
}


// WEBPACK FOOTER //
// ./src/lib/cache.ts